<app-header></app-header>

<!-- <router-outlet *ngIf="!showNav"></router-outlet> -->

<span >
  <!-- <div style="width: 100vw; height: 83px;"></div> -->
  <app-navigation> </app-navigation>
</span>